import { SxProps, Theme } from '@mui/system';

interface PropsType {
  style?: React.CSSProperties;
  color?: string;
  sx?: SxProps<Theme>;
}

const MypageIcon = ({ sx }: PropsType) => {
  return (
    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.5008 12.5C15.1833 12.5 17.358 10.3734 17.358 7.75C17.358 5.12665 15.1833 3 12.5008 3C9.8182 3 7.64355 5.12665 7.64355 7.75C7.64355 10.3734 9.8182 12.5 12.5008 12.5Z"
        fill="#E60012"
      />
      <path
        d="M5.23797 22C4.4936 22 3.89617 21.3611 4.01517 20.651C4.68182 16.7014 8.22759 13.6875 12.5007 13.6875C16.7739 13.6875 20.3196 16.7014 20.9851 20.651C21.1053 21.3611 20.5066 22 19.7635 22H5.23797Z"
        fill="#E60012"
      />
    </svg>
  );
};

export default MypageIcon;
